import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { ActiveSubscriptionResponseDto } from '../../commonTypes/organization.types';

export interface ActiveSubscriptionState {
    value: ActiveSubscriptionResponseDto | null;
    isReady: boolean;
}

const initialState: ActiveSubscriptionState = {
    value: null,
    isReady: false,
};

export const activeSubscriptionSlice = createSlice({
    name: 'activeSubscription',
    initialState,
    reducers: {
        setActiveSubscription: (state, action: PayloadAction<ActiveSubscriptionResponseDto | null>) => {
            state.value = action.payload;
            state.isReady = true;
        },
        resetActiveSubscription: () => initialState,
    },
});

export const selectActiveSubscription = (state: RootState) => state.activeSubscription.value;
export const selectActiveSubscriptionReady = (state: RootState) => state.activeSubscription.isReady;

export const { setActiveSubscription, resetActiveSubscription } = activeSubscriptionSlice.actions;
export default activeSubscriptionSlice.reducer;
